import React from "react";
import FormField from "./FormField";

interface TextInputFieldProps {
  id: string;
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string; // Optional type, defaults to "text"
  className?: string; // Optional additional class names for the input
  placeholder?: string;
  disabled?: boolean;
}

const TextInputField: React.FC<TextInputFieldProps> = ({
  id,
  label,
  value,
  onChange,
  type = "text",
  className = "",
  placeholder = "",
  disabled = false,
}) => {
  return (
    <FormField htmlFor={id} label={label || ""}>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        className={`focus:border-soluud-primary focus:ring-soluud-primary/30 block w-full rounded-lg border border-gray-300 py-2 pr-3 pl-3 text-base transition-colors duration-150 focus:ring-2 focus:outline-none sm:text-sm ${className}`}
        placeholder={placeholder}
        disabled={disabled}
      />
    </FormField>
  );
};

export default TextInputField;
